import React from 'react';

const MentalEdgeBlogPage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-green-100 to-yellow-100 py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold text-green-800 mb-4">The Mental Edge</h1>
            <p className="text-xl text-gray-700 mb-8">
              Weekly articles on the mental game of tennis.
            </p>
          </div>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <article className="bg-green-50 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-green-800 mb-4">Overcoming Choke Under Pressure</h3>
              <p className="text-gray-700 mb-4">Learn techniques to stay calm during crucial points.</p>
              <button className="text-green-600 hover:text-green-700 font-semibold">Read More</button>
            </article>
            <article className="bg-yellow-50 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-green-800 mb-4">Building Confidence on Court</h3>
              <p className="text-gray-700 mb-4">Strategies to develop unshakeable self-belief.</p>
              <button className="text-yellow-600 hover:text-yellow-700 font-semibold">Read More</button>
            </article>
            <article className="bg-green-50 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-green-800 mb-4">Mental Preparation Routines</h3>
              <p className="text-gray-700 mb-4">Pre-match rituals that set you up for success.</p>
              <button className="text-green-600 hover:text-green-700 font-semibold">Read More</button>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MentalEdgeBlogPage;

